import { useCopyToClipboard } from "usehooks-ts"
import { useToast } from "@mallardbay/lib-react-components"

import { useNativeShare } from "~utils/use-native-share"
import COPY from "~config/copy-constants"
import { trackShare } from "~utils/event-tracking/event-tracking-helpers"
import { ShareMethod } from "~utils/event-tracking/event-tracking-constants"

export function useCopyOrShare() {
    const { share, isSupported } = useNativeShare()
    // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars
    const [_copiedValue, copy] = useCopyToClipboard()
    const { showSuccess } = useToast()

    return async () => {
        const currentUrl = window.location.href

        if (isSupported) {
            await share({ url: currentUrl })
        } else {
            await copy(currentUrl)
            showSuccess(COPY.SHARE.LINK_COPIED)
        }

        trackShare({
            method: isSupported ? ShareMethod.NATIVE : ShareMethod.COPY,
            url: currentUrl,
        })
    }
}
